<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  methods:{
    ...mapMutations(['puUrl_x_save', 'fixedArea_save']),
    imgUrl_search() {
      // 获取图片终端
      this.$api.getPublicFileUrl().then(res => {
        if (res.data.status == 0) {
          let _R = res.data.data
          this.puUrl_x_save(_R)
          // console.log('%c公共图片终端：', 'color:red', _R)
          // console.log('%c公共图片终端：', 'color:red', this.puUrl_x)
        } else {
          console.log(`%c请求公共终端失败:`, 'color: #f00;', )
        }
      })
      // this.$api.picUrl_get_pr().then(res => {
      //   if (res.data.status == 0) {
          // let _R = res.data.data
          // getApp().globalData.prUrl_a = _R
      //     console.log('%c私有图片终端：', 'color:red', _R)
      //   } else {
      //     uni.showToast({ title: '请求私有终端失败', icon: 'none' })
      //   }
      // })
    },
    // 获取地理位置
    getArea(index, areaId, areaArrs) {
      console.log(`%cgetArea触发`, 'color: #00f;', Number(index), areaId)
      if (Number(index) < 4) {
        let rD = { areaId }
        return this.$api.getPlace(rD).then(res => {
          if (res.data.status === 0 ) {
            let _R = JSON.parse(res.data.data)
            // console.log(_R)
            const mapList = Object.keys(areaArrs)
            areaArrs[mapList[Number(index) + 1]] = _R
            // console.log(areaArrs.city)
          } else { this._status(res.data) }
        })
      } else {
        console.log(`%c已经是最后的村级了`, 'color: #f00;')
      }
    },
    //设置默认地址
    getDefault(areaArrs, areaNames, areaIds, dis) {
      let { admin, areaId } = this.userInfo
      if (admin) {
        for (let i = 0; i < 5; i++) { dis.push(false) }
      } else {
        return this.$api.getFather({ areaId }).then(async res => {
          if (res.data.status === 0) {
            let _R = JSON.parse(res.data.data)
            console.log(`%c默认地区:`, 'color: #00f;', _R)
            _R.forEach((x, i) => {
              areaIds[x.level] = x.id
              areaNames[x.level] = x.name
              dis[x.level] = i !== 4
            })
            for (let i in areaIds) {
              // console.log(i, areaIds[i])
              await this.getArea(Number(i), areaIds[i], areaArrs)
              // console.log(areaArrs.city)
            }
            // areaIds.forEach(async (x, i) => { 
            //   await this.getArea(i, x, areaArrs)
            //   console.log(areaArrs.city)
            // })
            // console.log('save!!!!!!!!!')
            this.fixedArea_save({ areaArrs, areaNames, areaIds, dis })
          } else { this._status(res.data) }
        })
      }
    },
  },
  async created() {
    this.imgUrl_search()

    console.log(`%careaIds_x:`, 'color: #f00;', this.areaIds_x.length)
    console.log(`%cthis.userInfo:`, 'color: #00f;', this.userInfo)
    if (this.userInfo) {
      let areaArrs = {
        province: [],
        city: [],
        county: [],
        town: [],
        village: [],
      }
      let areaNames = []
      let areaIds = []
      let dis = []

      if (this.userInfo.admin) {
        await this.getArea(-1, '0', areaArrs)
        this.fixedArea_save({ areaArrs, areaNames, areaIds, dis })
      } else if (this.areaIds_x.length === 0) {
        await this.getArea(-1, '0', areaArrs)
        this.getDefault(areaArrs, areaNames, areaIds, dis)
        console.log('app created')
      } else{
      }
    }
  },
}
</script>

<style>
body,html{margin: 0;padding: 0;height: 100%;}
@font-face {
  font-family: 'iconfont';  /* project id 1767497 */
  src: url('//at.alicdn.com/t/font_1767497_pzu7rycqna.eot');
  src: url('//at.alicdn.com/t/font_1767497_pzu7rycqna.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_1767497_pzu7rycqna.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_1767497_pzu7rycqna.woff') format('woff'),
  url('//at.alicdn.com/t/font_1767497_pzu7rycqna.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_1767497_pzu7rycqna.svg#iconfont') format('svg');
}
.iconfont{
  font-family:"iconfont" !important;
  font-size:16px;font-style:normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
i{font-style: normal;}
.clearfix :after{width: 0px;height: 0px;display: inline-block;clear: both;content: "";}
.red{color: red;}

.fr{float: right;}
.fl{float: left;}
.w1200{margin: 0px auto;width: 1200px;}
.w1000{margin: 0px auto;width: 1000px;}
*{list-style: none;margin: 0;padding: 0;text-decoration: none;}
a{color: #303133;}
#app{height: 100%;}
.table{padding-left: 15px;margin-top: 10px;}
/* 模态框样式 */
.index .el-dialog__wrapper{overflow: hidden;}
.index .el-dialog {height: 100%;margin-top: 0!important;overflow-y: auto;}
.edit{padding-left: 15px;margin-right: 10px;display: inline;}
.edit-box{height: 100%;border: 1px solid #ccc;border-radius: 5px;width: 100%;margin-bottom: 15px;}
.edit-box .edit-item{display: flex;justify-content: flex-start;}
.edit-item .edit-left{flex: 0 0 50px;background: #1E9FFF;writing-mode:vertical-lr;text-align: center;line-height: 50px;color: #fff;}
.edit-item .edit-right{flex: 0 0 96%;padding-top: 30px;}

.input-box{display: flex;flex-direction: row;justify-content: flex-start;min-width: 1400px;}
.info-input{/* padding: 50px; */width: 100%;}
.info-title{text-align:center;margin:48px 0;color:rgb(153,153,153);}
.index .el-table__body::-webkit-scrollbar{z-index: 10000;width:0px;opacity:0;-webkit-overflow-scrolling: touch;}

#container .amap-marker-label {
  border: 0 none;
  background-color: #fff;
  white-space: nowrap;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, .3);
  border-radius: 5px;
  line-height: 18px;
  padding: 0;
}

#container .amap-marker-label:after {
  content: '';width: 0;height: 0;
  position: absolute;top: 19px;left: 43%;
  border: 5px solid transparent;
  border-top-color: #fff;
}

.map_province {color: rgba(43, 43, 43, 0.79);}
.map_province > .map_province_title{padding-left: 4px;}

.map_province > .map_province_title, .map_province > .map_province_conter {display: inline-block;}

.map_province_conter {
  padding: 0 4px;
  margin-left: 4px;
  color: #fff;
  background-color: #477BD8;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
  .map_province_city{background-color: #DDD05E;}
  .map_province_area{background-color: #6EC245;}
  .map_province_county{background-color: #D847A7;}
  .map_province_village{background-color: #1be1fe;}


  .flex {display: flex;align-items: center;}
  /* 文本超出部分隐藏且不换行，多余省略号 */
  .textoverhiden{overflow: hidden;text-overflow:ellipsis;white-space: nowrap;}

  div, h1, h2, h3, h4, h5, h6, a, span, p, input, textarea, select, button {font-family:'微软雅黑',sans-serif;outline:none;}
</style>
